import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { ISignatureOrderSigners } from '@src/context/interfaces/external-components.interface'
import type { IActionsCallbacks, IColumnsHeadersOverwrite, IPermissions } from '@src/interfaces'

export interface IBasePropsState {
  context: string | null
  baseUrl: string | null
  resource: number | null
  nodes?: {
    newTemplateHeaderNode?: React.ReactNode
    editTemplateHeaderNode?: React.ReactNode
  }
  actionsCallback?: IActionsCallbacks
  overwriteColumns?: IColumnsHeadersOverwrite[]
  permissions?: IPermissions | undefined
  isSignatureFlow?: boolean
  biometric?: boolean
  documentType?: boolean
  tags?: boolean
  t?: any
  url?: string
  q?: any
  handleReturn?: () => void
  components?: {
    registerSignatureOrderSigners?: React.FC<ISignatureOrderSigners>
  }
  filterWorkspaceCallback?: (key: string) => boolean
  onDuplicate?: (token: string) => void
}

const initialState: IBasePropsState = {
  context: null,
  baseUrl: null,
  resource: null
}

export const basePropsSlice = createSlice({
  name: 'baseProps',
  initialState,
  reducers: {
    setBaseProps: (state, action: PayloadAction<IBasePropsState>) => {
      const { baseUrl, context, resource } = action.payload
      state.baseUrl = baseUrl
      state.context = context
      state.resource = resource
    },
    clearBaseProps: (state) => {
      state.baseUrl = null
      state.context = null
      state.resource = null
    }
  }
})

export const { setBaseProps, clearBaseProps } = basePropsSlice.actions

export default basePropsSlice.reducer
